// extracted by mini-css-extract-plugin
module.exports = {"option":"TerminalSelect_option__3ccGU","label":"TerminalSelect_label__OttYA","description":"TerminalSelect_description__G5zb2"};